// Acoustic Calculator Data and Configuration
window.AcousticCalculatorData = {
  // Constants
  minimumGoodRec: 15,
  minimumBestRec: 48,
  wallMaxVolume: 3500,
  ceilingMaxVolume: 35000,

  // Room types for walls
  rooms: [
    {
      id: "music_entertainment",
      label: "Music Listening / Entertainment",
      reverberation_time: 0.9,
    },
    {
      id: "studying_working",
      label: "Studying / Working",
      reverberation_time: 0.6,
    },
    {
      id: "recording_podcasting",
      label: "Recording / Podcasting",
      reverberation_time: 0.5,
    },
    {
      id: "video_phone",
      label: "Video / Phone",
      reverberation_time: 0.8,
    },
    {
      id: "living",
      label: "Living",
      reverberation_time: 0.7,
    },
  ],

  // Materials data
  wallMaterials: [
    {
      value: "gypsum_board",
      label: "Gypsum board",
      "4000hz": 0.05,
      "2000hz": 0.06,
      "1000hz": 0.06,
      "500hz": 0.08,
    },
    {
      value: "concrete_block",
      label: "Concrete Block",
      "4000hz": 0.05,
      "2000hz": 0.05,
      "1000hz": 0.06,
      "500hz": 0.07,
    },
    {
      value: "solid_concrete",
      label: "Solid Concrete",
      "4000hz": 0.03,
      "2000hz": 0.02,
      "1000hz": 0.02,
      "500hz": 0.01,
    },
    {
      value: "glass",
      label: "Glass",
      "4000hz": 0.02,
      "2000hz": 0.02,
      "1000hz": 0.03,
      "500hz": 0.04,
    },
  ],

  ceilingMaterials: [
    {
      value: "gypsum_board",
      label: "Gypsum board",
      "4000hz": 0.09,
      "2000hz": 0.07,
      "1000hz": 0.04,
      "500hz": 0.05,
    },
    {
      value: "natural_wood",
      label: "Natural Wood",
      "4000hz": 0.09,
      "2000hz": 0.08,
      "1000hz": 0.09,
      "500hz": 0.1,
    },
    {
      value: "solid_concrete",
      label: "Solid Concrete",
      "4000hz": 0.03,
      "2000hz": 0.02,
      "1000hz": 0.02,
      "500hz": 0.02,
    },
    {
      value: "metal",
      label: "Metal",
      "4000hz": 0.02,
      "2000hz": 0.07,
      "1000hz": 0.1,
      "500hz": 0.1,
    },
    {
      value: "acoustic_ceiling_tile",
      label: "Acoustic Ceiling Tile (ACT)",
      "4000hz": 0.59,
      "2000hz": 0.69,
      "1000hz": 0.74,
      "500hz": 0.5,
    },
  ],

  floorMaterials: [
    {
      value: "natural_wood",
      label: "Natural Wood",
      "4000hz": 0.08,
      "2000hz": 0.1,
      "1000hz": 0.11,
      "500hz": 0.12,
    },
    {
      value: "concrete",
      label: "Concrete, Vinyl, Hard Tiles",
      "4000hz": 0.02,
      "2000hz": 0.02,
      "1000hz": 0.02,
      "500hz": 0.02,
    },
  ],

  ceilingProducts: [
    {
      url: "https://feltright.com/products/fin-ceiling-cloud-baffle",
      value: "felt_right_cloud_baffles",
      label: `Cloud Baffles (4' x 4')`,
      unit: "Baffles",
      "4000hz": 27.2,
      "2000hz": 22.85,
      "1000hz": 17.29,
      "500hz": 13.85,
    },
    {
      value: "felt_right_blade_baffles",
      label: `Blade Baffles (8' x 8"), 12" spacing`,
      url: "https://feltright.com/products/mineral-ceiling-blade",
      unit: "Baffles",
      "4000hz": 11.58,
      "2000hz": 9.85,
      "1000hz": 6.72,
      "500hz": 4.89,
    },
    {
      url: "https://feltright.com/products/4-foot-wood-acoustic-beams",
      value: "felt_right_beams_12_oc",
      label: `Beams (8' x 7" x 3"), 12" spacing`,
      unit: "Beams",
      "4000hz": 12.11,
      "2000hz": 11.55,
      "1000hz": 9.22,
      "500hz": 6.63,
    },
  ],

  // Absorption coefficients
  absorptionCoefficients: {
    wall_coverings: {
      "4000hz": 0.73,
      "2000hz": 0.7,
      "1000hz": 0.63,
      "500hz": 0.38,
    },
    entryways: {
      "4000hz": 0.5,
      "2000hz": 0.5,
      "1000hz": 0.5,
      "500hz": 0.5,
    },
    floor_coverings_thin: {
      "4000hz": 0.4,
      "2000hz": 0.35,
      "1000hz": 0.2,
      "500hz": 0.08,
    },
    floor_coverings_heavy: {
      "4000hz": 0.73,
      "2000hz": 0.71,
      "1000hz": 0.69,
      "500hz": 0.57,
    },
    seating_plush: {
      "4000hz": 0.7,
      "2000hz": 0.82,
      "1000hz": 0.88,
      "500hz": 0.8,
    },
  },

  percentages: [0, 20, 40, 60, 80, 100],

  // Ceiling message templates
  ceilingMessageA69:
    "Felt Right ceiling products at this level should tame the upper end of the vocal range (1 kHz and above at a minimum) including consonant sounds, making speech easier to understand.",
  ceilingMessageA70:
    "Felt Right ceiling products at this level should tame the mid to upper end of the vocal range (500 Hz and above at a minimum). You can expect great intelligibility and reduced reverberation.",
  ceilingMessageA71:
    "This space may have acceptable acoustics for your intended use. Felt Right ceiling products may still help if you think the room doesn't sound quite right, or to add visual appeal to the space.",

  // Default settings
  defaultSettings: {
    surface_type: "commercial",
    room_use: [{ id: "living", label: "Living", reverberation_time: 0.7 }],
    room_use_ceiling: [],
    room_use_ceiling_ids: [],
    selectedRoomTypes: ["restaurant"],
    open_entryways: 1,
    plush_seats: 1,
    room_length: 12,
    room_width: 12,
    room_height: 8,
    soft_surfaces_wall: 0,
    floor_coverage: 20,
    // Ceiling-specific settings
    soft_surfaces_ceiling: 0,
    open_entryways_ceiling: 1,
    plush_seats_ceiling: 1,
    floor_coverage_ceiling: 20,
    wall_material_ceiling: "",
    ceiling_material: "",
    floor_material_ceiling: "",
    ceiling_product: "",
    quantity_mode: "ideal",
  },
};
